import { VarKey } from '../../Variables/Generated/VarKey.Data'
import { CoreType } from '../../Core/Core.Interfaces'
import { GenericTableSchemaInterface } from '../../Table/Table.Interfaces'

export const SizeDescriptions00Table: GenericTableSchemaInterface = {
  id: 'sizedescriptions-00',
  name: 'Size Descriptions 00',
  description: 'This table contains data around size descriptions in My Storage.',
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: 'Operator Name',
      variable: VarKey.OrgName
    },
    c02: {
      name: 'Facility ID',
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: 'Small'
    },
    c04: {
      name: 'Medium'
    },
    c05: {
      name: 'Large'
    },
    c06: {
      name: 'Extra Large'
    },
    c07: {
      name: '1 Bedroom'
    },
    c08: {
      name: '2 Bedrooms'
    },
    c09: {
      name: '3 Bedrooms'
    },
    c10: {
      name: '4-5 Bedrooms'
    },
    c11: {
      name: '5x5'
    },
    c12: {
      name: '5x10'
    },
    c13: {
      name: '10x10'
    },
    c14: {
      name: '10x15'
    },
    c15: {
      name: '10x20'
    },
    c16: {
      name: '10x30'
    },
    c17: {
      name: 'Small Vehicle'
    },
    c18: {
      name: 'Motorcycle'
    },
    c19: {
      name: 'Sedan'
    },
    c20: {
      name: 'Truck'
    },
    c21: {
      name: 'RV'
    }
  }
}
